import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../utils/api';
import { BRAND } from '../brand';

const Sidebar = ({ items, type = 'user' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [badges, setBadges] = useState({});

  useEffect(() => {
    if (type !== 'admin') return;
    let cancelled = false;
    const loadBadges = async () => {
      try {
        const r = await api.get('/admin/uaf-alerts/summary');
        if (!cancelled) {
          setBadges((b) => ({
            ...b,
            'uaf-alerts': (r.data?.open_high || 0) + (r.data?.open_medium || 0),
          }));
        }
      } catch (e) {
        // silencioso
      }
    };
    loadBadges();
    const t = setInterval(loadBadges, 60000);
    return () => { cancelled = true; clearInterval(t); };
  }, [type]);

  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleNavigation = (path) => {
    navigate(path);
    setIsOpen(false); // Cerrar menú al navegar en móvil
  };

  return (
    <>
      {/* Mobile Menu Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="lg:hidden fixed top-4 left-4 z-50 p-2 rounded-lg bg-white shadow-lg"
        style={{borderColor: 'var(--brand-primary)', borderWidth: '2px'}}
      >
        <svg className="w-6 h-6" style={{color: 'var(--brand-primary)'}} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          {isOpen ? (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          ) : (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          )}
        </svg>
      </button>

      {/* Overlay para móvil */}
      {isOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`
          fixed
          inset-y-0 left-0
          transform ${isOpen ? 'translate-x-0' : '-translate-x-full'}
          lg:translate-x-0
          transition-transform duration-300 ease-in-out
          w-64 bg-white shadow-lg
          z-40
          overflow-y-auto
        `}
      >
        {/* Logo Header */}
        <div className="p-6 border-b-2" style={{borderColor: '#e0e0e0'}}>
          <img src="/logo.png" alt={`${BRAND.name}`} className="h-20 mx-auto" />
          {type === 'admin' && (
            <div className="mt-3 text-center">
              <span className="bg-yellow-400 text-gray-900 px-3 py-1 rounded-full text-xs font-bold">
                ADMINISTRADOR
              </span>
            </div>
          )}
        </div>

        {/* Menu Items */}
        <nav className="p-4">
          <ul className="space-y-1">
            {items.map((item, index) => (
              <li key={index}>
                {item.type === 'separator' ? (
                  <div className="pt-3 pb-1 px-4">
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">{item.label}</p>
                  </div>
                ) : (
                  <button
                    onClick={() => handleNavigation(item.path)}
                    className={`w-full flex items-center gap-3 px-4 py-2.5 rounded-lg transition font-semibold text-left text-sm ${
                      isActive(item.path)
                        ? 'text-white'
                        : 'text-gray-700 hover:bg-gray-100'
                    }`}
                    style={isActive(item.path) ? {backgroundColor: 'var(--brand-primary)'} : {}}
                    data-testid={`sidebar-${item.path}`}
                  >
                    <span className="text-lg">{item.icon}</span>
                    <span className="flex-1">{item.label}</span>
                    {item.badgeSource && badges[item.badgeSource] > 0 && (
                      <span
                        className="bg-red-500 text-white text-[10px] font-bold rounded-full px-2 py-0.5 min-w-[20px] text-center"
                        data-testid={`sidebar-badge-${item.badgeSource}`}
                      >
                        {badges[item.badgeSource] > 99 ? '99+' : badges[item.badgeSource]}
                      </span>
                    )}
                  </button>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
